export default "__VITE_ASSET__iqNGKn16__"